import React, { ReactNode } from "react";
import * as S from "./style";
export interface PopupProps {
  visible: boolean;
  setVisible: () => void;
  content?: ReactNode;
  onlyOk?: boolean;
  okEvent?: () => void;
  noBtn?: boolean;
  title?: string;
  cancelText?: string;
  okText?: string;
  className?: string;
  cancelEvent?: () => void;
  btnColor?: string;
}

const ModalDefault: React.FC<PopupProps> = ({
  visible,
  setVisible,
  content,
  onlyOk,
  okEvent,
  noBtn,
  title = "",
  cancelText,
  okText,
  className,
  cancelEvent,
  btnColor,
}) => {
  return (
    <>
      <S.ModalPopup
        visible={visible}
        width={"max-content"}
        closable={false}
        footer={null}
        onCancel={() => setVisible()}
        centered
        className={className}
      >
        <S.Container>
          {title && <div className="title">{title}</div>}
          {content}
          {!noBtn && (
            <S.WrapperButton mypage={true} onlyOk={onlyOk}>
              {!onlyOk ? (
                <>
                  <S.ButtonCancel
                    onClick={() => {
                      if (cancelEvent) cancelEvent();
                      setVisible();
                    }}
                  >
                    {cancelText ?? "취소"}
                  </S.ButtonCancel>
                  <S.ButtonConfirm
                    id="btn"
                    className="mrl-20"
                    onClick={okEvent}
                  >
                    {okText ?? "확인"}
                  </S.ButtonConfirm>
                </>
              ) : (
                <S.ButtonConfirm onClick={okEvent} style={{ backgroundColor: btnColor }}>
                  {okText ?? "확인"}
                </S.ButtonConfirm>
              )}
            </S.WrapperButton>
          )}
        </S.Container>
      </S.ModalPopup>
    </>
  );
};

export default ModalDefault;
